
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
import { defineComponent, reactive, ref } from "vue";
import { UploadOutlined } from "@ant-design/icons-vue";

import router from "@/router";
import Header from "@/components/Header.vue";
import { toastError } from "../utils/toastError";
import { getFromLS } from "@/utils/localStorage";
import { patientService } from "@/services/patients";
import { IPatient, IPatientResponse } from "@/types/patients";

export default defineComponent({
  props: {
    paramId: {
      type: String,
    },
  },
  components: {
    UploadOutlined,
    Header,
  },
  computed: {
    ...mapState(["patients"]),
  },
  setup(props) {
    const loading = ref<boolean>(false);
    const toast = useToast();
    let iData: string;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    const allergiesList = [
      "Crustacean Allergies",
      "Gluten Allergies",
      "Egg Allergies",
      "Peanut Allergies",
      "Milk Allergies",
      "Pet Allergies",
      "Pollen Allergies",
      "Dust Mite Allergies",
      "Mold Allergies",
      "Sulfite Allergies",
    ];

    const formState = reactive<Record<string, any>>({});
    function handleChange(info: any) {
      if (info.file.status === "done") {
        iData = info.file.response;
      } else if (info.file.status === "error") {
        toast.error(info.file.response.error ?? "error uploading image.");
      }
    }

    const onFinish = (values: IPatient) => {
      loading.value = true;

      const { image, ...patientData } = values;
      if (props.paramId) {
        patientService
          .updatePatient({ ...patientData, image: iData }, Number(props.paramId))
          .then(() => {
            loading.value = false;
            toast.success("Patient updated successfully...");
            setTimeout(() => router.push("/dashboard"), 1000);
          })
          .catch((err) => {
            loading.value = false;
            toastError(err);
          });
      } else {
        patientService
          .addPatient({ ...patientData, image: iData })
          .then(() => {
            loading.value = false;
            toast.success("Patient created successfully...");
            setTimeout(() => router.push("/dashboard"), 1000);
          })
          .catch((err) => {
            loading.value = false;
            toastError(err);
          });
      }
    };

    return {
      loading,
      allergiesList,
      formState,
      onFinish,
      handleChange,
      formItemLayout,
    };
  },
  data() {
    return {
      currentPatient: {} as IPatientResponse,
      imageUrl: process.env.VUE_APP_API_URL + "/patients/upload-image",
      headers: {
        Authorization: `Bearer ${getFromLS("token")}`,
      },
    };
  },
  created() {
    const matched = this.patients?.filter((patient: IPatientResponse) => {
      if (this.paramId) {
        if (patient.id === parseInt(this.paramId)) {
          return patient;
        }
      }
    });
    this.currentPatient = matched && matched[0];
  },
});
